var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"bg-white shadow overflow-hidden rounded-md"},[_c('div',{staticClass:"px-6 py-4 text-center"},[_c('Loader')],1)]):(_vm.person)?_c('PersonCard',{attrs:{"person":_vm.person}}):_c('PersonCreateOrAssociate',{attrs:{"contact-id":_vm.contactId},on:{"changed":_vm.fetchPerson}})
}
var staticRenderFns = []

export { render, staticRenderFns }